module.exports = __webpack_public_path__ + "static/media/announcenew.3eaa5e65.svg";